import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import './style.scss';

const Teaser = ({ className = '', sections = [], i18nPrefix = '' }) => (
    <div className={classnames('landing-teaser', className)}>
        <h2 className="text-display-2">
            <I18n k={`${i18nPrefix}.teaser.section_title`} />
        </h2>
        <ul>
            {sections.map((section, index) => (
                <li key={index} className={section.class}>
                    <h3 className="text-display-7">
                        <I18n
                            k={`${i18nPrefix}.teaser.list_${section.id}.title`}
                        />
                    </h3>
                    <p>
                        <I18n
                            k={`${i18nPrefix}.teaser.list_${section.id}.description`}
                        />
                    </p>
                </li>
            ))}
        </ul>
    </div>
);

Teaser.propTypes = {
    className: PropTypes.string,
    sections: PropTypes.array,
    i18nPrefix: PropTypes.string,
};

export default Teaser;
